<template>
  <YazamData class="yazam" v-if="showYazamData" :yazam_data="entr_data" />
  <div id="last_details_publish" class="card" v-if="loaded">
    <div class="sections_list">
      <section class="lawyer_terms card_b active">
        <div class="head">
          <h3 class="title">תנאי עורך הדין ליזמים</h3>
        </div>
        <div class="content">
          <div class="editor-container" @click="handleRtlEditor">

            <QuillEditor
              v-model:content="form.lawyer_terms"
              contentType="html"
              theme="snow"
              :options="quill_options"
            />
          </div>
        </div>
      </section>

      <section class="agreement card_b active">
        <div class="head">
          <h3 class="title">הסכמים</h3>
        </div>
        <div class="content">
          <div class="required_file">
            <div class="text_content">
              <h4 class="title">הסכם חובה</h4>
              <p class="text">בהעלאת המסמך, הינך מצהיר/ה שההסכם נחתם כדין ע"י הדיירים</p>
            </div>
            <li class="gallery_box_container">
              <GalleryInput max_width="70"  v-model="form.file_agreement" @onUpload="form.file_agreement =  $event.id" :max="1" :isInputBox="true"  customLabel="הסכם שכר טירחה מול בעלי הדירות"/>	
              <!-- <GalleryInput  v-model="form.file_agreement" @onUpload="form.file_agreement =  $event.id" :max="1"  />	 -->
            </li>
          </div>
          <div class="optional_files">
            <div class="text_content">
              <h4 class="title">הסכמים נוספים שאינם חובה</h4>
              <p class="text">יש להעלות את ההסכמים הבאים במידה והם קיימים כדי שהיזם יוכל לשקף את העלויות הרלוונטיות במכרז</p>
            </div>
            <ul class="upload_files_container">
              <li class="gallery_box_container">
                <GalleryInput max_width="70" v-model="form.extra_file_1" @onUpload="form.extra_file_1 =  $event.id" :max="1" :isInputBox="true" customLabel="הסכם מארגן / 
מנהל פרויקט" />	
              </li>
              <li class="gallery_box_container">
                <GalleryInput max_width="70" v-model="form.extra_file_2" @onUpload="form.extra_file_2 =  $event.id" :max="1"  :isInputBox="true" customLabel="הסכם מפקח
בעלי הדירות" />	
              </li>
              <li class="gallery_box_container">
                <GalleryInput max_width="70" v-model="form.extra_file_3" @onUpload="form.extra_file_3 =  $event.id" :max="1" :isInputBox="true" customLabel="הסכם יועץ ביטוח" />	
              </li>
              <li class="gallery_box_container">
                <GalleryInput max_width="70" v-model="form.extra_file_4" @onUpload="form.extra_file_4 =  $event.id" :max="1" :isInputBox="true" customLabel="הסכם שמאי"  />	
              </li>
            </ul>
          </div>
        </div>
      </section>
      
      <section class="details card_b active">
        <div class="head">
          <h3 class="title">פרטים טכניים</h3>
        </div>
        <div class="content">
          <ul>
            <li class="">
              <p class="title">מועד סיום המכרז</p>
              <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="בחר תאריך" v-model="form.date_end">
              <span class="note">מינימום 14 יום. ההמלצה שלנו היא 30 יום</span>
            </li>
            <li class="">
              <p class="title">כתובות מייל לעדכונים</p>
              <textarea v-model="form.update_emails" cols="30" rows="10"></textarea>
              <span class="note">ניתן להוסיף עד 5 כתובות מופרדות בפסיק</span>
            </li>
            <li class="">
              <p class="title">כתובות מייל לעדכון נציגות הדיירים</p>
              <textarea v-model="form.tenants_emails" cols="30" rows="10"></textarea>
              <span class="note">ניתן להוסיף עד 5 כתובות מופרדות בפסיק</span>
            </li>
            <li class="">
              <p class="title">סוג המכרז</p>
              <div class="box_switch" :f="form.is_open">
                <div :class="{ selected: form.is_open == '1'}" @click="form.is_open = '1'" class="a">פתוח</div>
                <div :class="{ selected: !form?.is_open || form.is_open == '0'}" @click="form.is_open = '0'" class="b">סגור</div>
              </div>
            </li>
           
            <li class="">
              <p class="title">יזמים שאזמין למכרז יקבלו התראה  15 יום לפני סגירת מועד ההגשה</p>
              <div class="switch_container" >
                  <span>לא</span>
                  <div class="onoffswitch">
                      <input type="checkbox" v-model="form.fiften_days_alert"  name="onoffswitch-b" :id="'id-1'" class="onoffswitch-checkbox"  tabindex="0">
                      <label :for="'id-1'" class="onoffswitch-label"></label>
                  </div>
                  <span>כן</span>
              </div>
            </li>
            <li class="">
              <p class="title">   אני רוצה לאפשר לנציגות הדיירים להיות חשופים לשמות היזמים</p>
               <div class="switch_container" >
                  <span>לא</span>
                  <div class="onoffswitch">
                      <input type="checkbox" v-model="form.is_names_open"  name="onoffswitch-b" :id="'id-2'" class="onoffswitch-checkbox"  tabindex="0">
                      <label :for="'id-2'" class="onoffswitch-label"></label>
                  </div>
                  <span>כן</span>
              </div>
            </li>
             <li style="flex-basis: 50%; " class="" v-if="form.is_open == '1'">
              <p style="font-weight:600;margin-bottom:20px" class="title">סינון יזמים</p>
              <div class="filter_wrapper" v-for="filter in filters" :key="filter.id">
                 <span class="text" :data-filter-id="filter.id">{{filter.name}}</span>
                <div class="switch_container">
                        <span>לא</span>
                        <div class="onoffswitch">
                            <input type="checkbox" v-model="filter.active"  name="onoffswitch-b" :id="filter.id" class="onoffswitch-checkbox"  tabindex="0">
                            <label :for="filter.id" class="onoffswitch-label"></label>
                        </div>
                        <span>כן</span>
                  </div>
                </div>
            </li>
          </ul>
        </div>
      </section>
      <div class="list_p bg">
          <ul>
              <li>
                  <span>על מנת ליצור מכרז איכותי, הנה בחר לפחות כ-7 יזמים העונים על הצרוך של הדיירים במכרז</span>
              </li>
              <li>
                  <span>בחרת להמשיך עם <strong v-text="'מכרז ' + (+form.is_open ? 'פתוח' : 'סגור')"></strong> - בו כל יזם שרשום למערכת יכול להגיש מועמדות למכרז</span>
              </li>
              <li>
                  <span v-html="(+form.is_open ? 'למרות שהמכרז מוגדר כפתוח לכולם, ' : '') + ('ניתן <strong>לשלוח הזמנות</strong> ליזמים / חברות ספציפיות שלדעתך יתאימו למכרז זה')"></span>
              </li>
              <li> 
                  <span>כברירת מחדל, המערכת תציג לך <strong>קודם יזמים שמומלצים לפרטי המכרז שיצרת</strong> (מבוסס על שלב 'מידע קיים על הפרויקט' ביצירת המכרז)</span>
              </li>
          </ul>
      </div>
      <invitingEntrepreneurs :form="form" :more_filters="filters" :token="edit_token" @removeIvit="invitingEntrepreneursData = invitingEntrepreneursData.filter(item => item.id != $event)" @invitingEntrepreneursData="updateInvitingEntrepreneursData" />


      <section class="card_b active sum_submit_container active">
        <div class="head">
          <h3>סיכום פרטי המכרז לפני פרסומו</h3>
        </div>
        <div class="content">
          <!-- <div class="list_p" v-html="get_word('')"></div> -->
          <div class="list_p no_addtional_styles">
            <ul class="notes_list">
              <li v-if="form.date_end && form.date_end != '0000-00-00'">
                <p>לאחר אישורו ע"י צוות המכרז השקוף - המכרז שלך יפורסם ויופיע ליזמים עד לתאריך <strong v-text="form.date_end"></strong></p> 
              </li>
              <li>
                <p>בחרת להזמין <strong v-text="invitingEntrepreneursData.length"></strong> יזמים למכרז זה.  מיד לאחר אישור המכרז, הם יקבלו מייל עם קישור לפרטי המכרז המלא (כך נראה מייל לדוגמא)</p>
              </li>
              <li>
                <p>בחרת <strong v-if="!form.fiften_days_alert">לא</strong> לשלוח התראה 15 יום לפני סגירת מועד ההגשה - ליזמים שהוזמנו</p>
              </li>
              <li>
                <p>לאחר פרסום המכרז, הוא יופיע באזור ה 'מכרזים' בסרגל הניווט. משם ניתן יהיה לבצע פעולות נוספות ולשתף את הפרטים שלו עם נציגות הדיירים</p>
              </li>
            </ul>
          </div>
          <div class="btn_container">
            <div class="btn" @click="saveContract()">מאשר/ת, ניתן לפרסם את המכרז</div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>

import invitingEntrepreneurs from './invitingEntrepreneurs.vue';
import GalleryInput from '../GalleryInput.vue';
import YazamData from '../YazamData.vue';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  props:{
    edit_token: {
      type: String,
      required: true
    }
  },
  components: {
    invitingEntrepreneurs, 
    YazamData, 
    GalleryInput,
    QuillEditor
  },

  data() {
    return {
      is_set_rtl_editor: false,
      saveInterval: null,
      quill_options: {
        direction: 'rtl',
        placeholder: 'הזן את תנאי עורך הדין כאן...',
        // placeholder: 'Compose an epic...',
        modules: {

          toolbar: [
              ['bold'], 
              ['underline'], 
              [{ 'align': ['right', 'center'] }],
              [{ 'size':  ['small', false, 'large', 'huge'] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ]
        },
        theme: 'snow'
      },
      loaded: false,
      showYazamData: false,
      filters: [],

      entr_data: {},
      form: {
        is_open: '1',
        lawyer_terms: '',
      },
      invitingEntrepreneursData: [],
    }
  },
  mounted() {
     if(this.edit_token){
      this.api({ action: 'projects/get_project_data',data: {token: this.edit_token ,slim:true}} ,(data) => {
        // if (data.data?.external_data?.num_offers && +data.data?.external_data?.num_offers > 0) {
        //   this.$router.push({ name: 'project', params: { token: this.edit_token}})
        // }
        if(data.data){
          this.form = data.data;
          this.loaded = true;
        }
      });
    }
    else this.$route.push('/create_project');
      setTimeout(() => {
        this.api({ action: 'get_list', data: { id: 1463 }}, (data)=>{
        if(data.data){
          for(let i = 0; i < data.data.length; i++){
             data.data[i].active = false;
            for(let z = 0; z < this.form.open_filters.length; z++){
              if(data.data[i].id == this.form.open_filters[z]) data.data[i].active = true;
            }
            this.filters.push(data.data[i]);
          }
        }
      });
      }, 1000);
     
    
      this.$bus.$on('open_yazamdata', (data) => { this.showYazamData = true,this.entr_data = data });
      this.$bus.$on('close_yazamdata', () => { this.showYazamData = false });
  },



  methods:{
    handleRtlEditor() {
      if(!this.is_set_rtl_editor){
        this.is_set_rtl_editor = true;
        const firstPickerItem = document.querySelector('.ql-picker-item');
        if (firstPickerItem) {
          firstPickerItem.click();
        }
      }
    },

    updateInvitingEntrepreneursData(items) {
      for (let i = 0; i < items.length; i++) {
        if (!this.invitingEntrepreneursData.filter(it => it.id === items[i].id).length) {
          this.invitingEntrepreneursData.push(items[i])
        }
        
      }
    },
    saveContract(publish=true) {
        if(this.edit_token && this.edit_token != '') this.form.token = this.edit_token;
        const postData = this.form;
        postData.filters = this.filters;
        postData.set_active = publish;


      this.api({ action: 'projects/save_last_step', data: postData}, (data) => {
        if(data.data)
        {
          if(publish) {
            this.toast('המכרז פורסם בהצלחה' , 'success');
            this.$router.push('/projects_manager');
          }
        }
        else{
          this.toast('success', 'המכרז לא פורסם ');
        }
      });
    },
    autoSave() {
      this.saveContract(false);
    },
  }
}
</script>


<style lang="scss" >
.filter_wrapper{display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;gap: 20px;}
#last_details_publish {



  .sections_list { display: flex; flex-direction: column; gap: var(--gap_xmid);}
  // border-radius: 10px; border: 1px solid #d3d3d3; overflow: hidden;
  section {
    // >.head { padding: 15px; background-color: #f5f5f5; display: flex; justify-content: flex-start;border-bottom: 1px solid #d3d3d3;
    //   >.title { color: #333; font-weight: bold; font-size: 18px; }
    // }
    
  }
  .lawyer_terms {
    >.content {
      padding: 20px;
      
      .editor-container {
        
        // direction: rtl;
        // * {direction: rtl; text-align: right;}
        .ql-container  {
          min-height: 200px;
        }
        
        :deep(.ql-container) {
          min-height: 150px;
        }
        
        :deep(.ql-toolbar) {
          // direction: rtl;
          // * {direction: ltr;}
        }

        
        



      }
    }
  }
  .agreement {
    >.content { display: flex;
      ul {
        li {flex: 1;}
      }
      .required_file { flex: 1; padding: 30px 70px; display: flex; gap: 30px; flex-direction: column; justify-content: space-between; border-left: 1px solid #d3d3d3;
        .text_content { display: flex; flex-direction: column; gap: 5px;
          .title {}
          .text {}
        }
        .upload_file {
          .icon_container {
            i, svg {}
            p {}
          }
        }
      }
      .optional_files { flex: 3; padding-inline: 40px; padding-block: 30px; display: flex; flex-direction: column;justify-content: space-between;
        .text_content { display: flex; flex-direction: column; gap: 5px;
          .title {}
          .text {}
        }
        .upload_files_container { display: flex; gap: 25px; justify-content: space-between;
          li { 
          }
        }
      }
    }
  }
  .details {
    >.content { display: flex; padding-inline: 50px; padding-block: 30px;
      ul { display: flex; flex-wrap: wrap; column-gap: var(--gap_local); row-gap: 30px; --gap_local: 70px;
        li { flex-basis: calc(33.3% - var(--gap_local) * 2 / 3); display: flex; flex-direction: column; gap: 5px;
          textarea {height: 80px; width: 300px;}
          >span {font-size: 15px; color: #999;}
          input[type=date] { height: 40px; outline: none; border-radius: 3px;}
        }
      }
    }
  }

  .sum_submit_container {
    .content { display: flex; flex-direction: column; gap: var(--gap_xmid); }
    .btn_container { display: flex; justify-content: flex-end;
      .btn {width: fit-content;}
    }
  }

  

}
</style>